export default {
  nav: {
    dashboard: "Dashboard",
    announcements: "Announcements",
    time: "Time Tracking",
    pto: "Time Off",
    tasks: "Boards",
    goals: "My Goals",
    reviews: "My Reviews",
    shifts: "My Shifts",
    production: "My Production",
    checklists: "Checklists",
    training: "Training",
    orders: "Order Requests",
    support: "Support Tickets",
    oneOnOnes: "1:1 Notes",
    kudos: "Kudos",
    suggestions: "Suggestion Box",
    polls: "Polls",
    directory: "Directory",
    sops: "SOPs",
    handbook: "Handbook",
    resources: "Resources",
    chat: "Chat",
    profile: "My Profile",
  },
  dashboard: {
    hi: "Hi, {{name}}",
    status: "Status",
    clockedIn: "Clocked In",
    offTheClock: "Off the clock",
    since: "Since",
    today: "Today",
    thisWeek: "This week",
    verification: "Verification",
    clockIn: "Clock In",
    clockOut: "Clock Out",
    recentLogs: "Recent time logs",
    viewAll: "View all",
    noLogs: "No logs in the last 14 days.",
    sickCardTitle: "Not feeling well?",
    sickCardBody: "One tap submits a same-day time-off request and lets admin know.",
    sickButton: "🤒 Call out sick today",
    sickConfirm: "Call out sick today?",
    sickConfirmBody: "This submits a same-day time off request marked \"sick\" and pings admin.",
    sickThanks: "Thanks — admin has been notified. Feel better.",
    mobileBlocker: "Clock in from a desktop",
    mobileBlockerBody: "For accurate time tracking, please clock in on a desktop or the warehouse kiosk.",
  },
  kiosk: {
    pickName: "Tap your name, enter your PIN to clock in or out.",
    enterPin: "Enter your PIN",
    cancel: "Cancel",
    clockAction: "Clock In / Out",
    forgotPin: "Forgot my PIN",
    forgotPinSent: "Admin notified — they'll reset your PIN.",
    noPinSet: "No PIN set",
    cameraDenied: "Camera access denied",
    cameraUnavailable: "Camera not available",
    cameraStarting: "Starting camera…",
    retry: "Retry",
  },
  timeoff: {
    title: "Time Off",
    newRequest: "+ Request Time Off",
    unpaidNotice: "Heads up — time off is currently **unpaid**. Submit your dates and your manager will approve or deny.",
    upcomingApproved: "Upcoming approved time off",
    startDate: "Start date",
    endDate: "End date",
    reason: "Reason",
    notes: "Notes",
    notesPlaceholder: "Any context for your manager…",
    submit: "Submit request",
    cancel: "Cancel",
    confirmCancel: "Cancel this time off request?",
    myRequests: "My requests",
    noRequests: "No requests yet.",
    reasons: {
      vacation: "Vacation",
      sick: "Sick",
      personal: "Personal",
      bereavement: "Bereavement",
      jury_duty: "Jury duty",
      other: "Other",
    },
    status: {
      pending: "pending",
      approved: "approved",
      denied: "denied",
      cancelled: "cancelled",
    },
  },
  common: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    yes: "Yes",
    no: "No",
    loading: "Loading…",
    actions: "Actions",
  },
  profile: {
    title: "My Profile",
    saved: "Saved",
    sections: {
      personal: "Personal",
      contact: "Contact",
      emergency: "Emergency",
      banking: "Banking & Tax",
      documents: "Documents",
      security: "Security",
    },
    firstName: "First name",
    lastName: "Last name",
    middleName: "Middle name",
    preferredName: "Preferred name",
    preferredPronouns: "Pronouns (he/him, she/her, they/them)",
    dateOfBirth: "Date of birth",
    maritalStatus: "Marital status",
    gender: "Gender",
    bio: "Bio",
    linkedinUrl: "LinkedIn URL",
    shirtSize: "Shirt size (for swag)",
    languages: "Languages",
    phone: "Cell phone",
    homePhone: "Home phone",
    personalEmail: "Personal email",
    address: "Mailing address",
    city: "City",
    state: "State",
    zipCode: "Zip",
    changePassword: "Change Password",
    newPassword: "New password",
    update: "Update",
    account: "Account",
    username: "Username (for @tagging)",
    employeeNumber: "Employee #",
    email: "Email",
    role: "Role",
    memberSince: "Member since",
    appearance: "Appearance",
    matchSystem: "Match system",
    light: "Light",
    dark: "Dark",
    language: "Language",
    twoFactor: "Two-factor authentication",
    enable2fa: "Enable 2FA",
    scanQr: "Scan this QR code with your authenticator app, then enter the 6-digit code it shows.",
    enterCode: "Enter the 6-digit code",
    verify: "Verify",
    removeFactor: "Remove",
    upload: "Upload",
    uploadFile: "Choose File",
    myDocuments: "My documents",
    nothingUploaded: "Nothing uploaded yet.",
  },
  polls: {
    title: "Polls",
    subtitle: "Vote anonymously — your name isn't recorded.",
    newPoll: "New poll",
    noPolls: "No polls right now.",
    question: "Question",
    description: "Description",
    optional: "optional",
    options: "Options",
    addOption: "+ Add option",
    multiSelect: "Multi-select",
    closesAt: "Closes at",
    open: "open",
    closed: "closed",
    multiSelectShort: "multi-select",
    vote: "Vote",
    alreadyVoted: "You already voted on this poll.",
    votes: "votes",
    closes: "closes",
    close: "Close",
    reopen: "Reopen",
    delete: "Delete",
    errorNeedTwoOptions: "Need a question and at least 2 options.",
    create: "Create poll",
    creating: "Creating…",
  },
  chat: {
    channels: "Channels",
    directMessages: "Direct Messages",
    noOthers: "No other employees yet.",
    selectConversation: "Select a conversation",
    noMessages: "No messages yet. Say hi.",
    messagePlaceholder: "Message {{name}} — use @ to mention",
    startHuddle: "Start huddle",
    huddleRunning: "Huddle running at",
    copy: "copy",
    delete: "delete",
    send: "Send",
    noConversation: "Select a conversation",
  },
};
